import { checkboxAnatomy } from '@chakra-ui/anatomy';
import {
  Checkbox as ChakraCheckbox,
  CheckboxProps,
  createMultiStyleConfigHelpers
} from '@chakra-ui/react';
import { forwardRef } from 'react';
export { CheckboxGroup } from '@chakra-ui/react';
export type { CheckboxGroupProps, CheckboxProps } from '@chakra-ui/react';

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (props, ref): JSX.Element => {
    return <ChakraCheckbox {...props} ref={ref} />;
  }
);

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    colorScheme: 'blue',
    _disabled: {
      color: 'gray'
    }
  },
  label: {
    baselineShift(theme) {
      return {
        fontSize: ['lg', 'xl'].includes(theme.size) ? 'md' : 'sm',
        fontWeight: 'bold',
        paddingLeft: 'space_unit-x1'
      };
    }
  }
});

export const CheckboxTheme = defineMultiStyleConfig({
  baseStyle
});
